import { Box, CircularProgress } from "@mui/material";

export default function Spinner(props: { condition?: boolean }) {
    const condition = props?.condition ?? true;

    if (condition) {
        return (
            <Box
                sx={{
                    display: "flex",
                    width: "100%",
                    height: "100%",
                    minWidth: 100,
                    minHeight: 100,
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    return <></>;
}
